import { useSelector } from 'react-redux';
import * as selectors from '../../../modules/accessSettings/selectors';

export function useGetApartmentFormData() {
  const isAddingApartment = useSelector(selectors.isAddAccessGroupApartmentsFetching);
  const isOptionsLoading = useSelector(selectors.isAccessControlApartmentsFetching);
  const optionsData = useSelector(selectors.getAccessControlApartmentsFiltered);

  return {
    isLoading: isAddingApartment,
    isOptionsLoading,
    optionsData,
  };
}
